/* ==========================================
   NAVURA - Category drawer

   Fully independent from Dawn's header-drawer (hamburger menu) — separate
   element, separate state, no shared IDs. Opens from any element carrying
   [data-navura-open-category-drawer] (top nav + bottom nav Categories
   items). Locks background scroll while open, restores it on close,
   closes on Escape/overlay/close-button, and returns focus to whichever
   trigger opened it.
========================================== */

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('[data-navura-category-drawer]');
    if (!drawer) return;

    var panel = drawer.querySelector('.navura-category-drawer__panel');
    var sidebarItems = drawer.querySelectorAll('[data-navura-group]');
    var panels = drawer.querySelectorAll('[data-navura-group-panel]');
    var openTriggers = document.querySelectorAll('[data-navura-open-category-drawer]');
    var closeTriggers = drawer.querySelectorAll('[data-navura-category-drawer-close]');
    var lastFocused = null;
    var scrollY = 0;

    function open(trigger) {
      lastFocused = trigger || document.activeElement;
      scrollY = window.scrollY;

      drawer.hidden = false;
      document.documentElement.classList.add('navura-scroll-lock');
      document.body.style.top = '-' + scrollY + 'px';

      document.dispatchEvent(new CustomEvent('navura:category-drawer-open'));

      var closeButton = drawer.querySelector('.navura-category-drawer__close');
      if (closeButton) closeButton.focus();

      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      drawer.hidden = true;
      document.documentElement.classList.remove('navura-scroll-lock');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);

      document.dispatchEvent(new CustomEvent('navura:category-drawer-close'));

      document.removeEventListener('keydown', onKeydown);

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = panel.querySelectorAll(
        'button, a[href], input, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function selectGroup(groupId) {
      sidebarItems.forEach(function (item) {
        var isActive = item.getAttribute('data-navura-group') === groupId;
        item.classList.toggle('navura-category-drawer__sidebar-item--active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (group) {
        group.hidden = group.getAttribute('data-navura-group-panel') !== groupId;
      });
    }

    openTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        open(trigger);
      });
    });

    closeTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', close);
    });

    sidebarItems.forEach(function (item) {
      item.addEventListener('click', function () {
        selectGroup(item.getAttribute('data-navura-group'));
      });
    });

    window.navuraCloseCategoryDrawer = close;
  });
})();
